import styled from 'styled-components';
import { ReactComponent as ArrowSVG } from 'Images/arrow-right.svg';

export const menuItemHeight = 36;

export const StyledMenuItem = styled.div`
  display: flex;
  flex-direction: row;
  user-select: none;
  align-items: center;
  flex: 1 1 auto;
  background: 0 0;
  border: 0;
  cursor: pointer;
  font-weight: ${({ isSelected }) => (isSelected ? 500 : 300)};
  line-height: 1.5;
  text-align: inherit;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: ${`${menuItemHeight}px`};
  padding: 7px 15px;
  outline: none;
  font-size: 14px;
  color: ${({ color, theme }) => color || theme.text.contextMenu};
  text-transform: ${({ capitalize }) => capitalize ? 'capitalize' : 'none'};
  &:hover {
    background-color: ${({ theme }) => theme.backgrounds.contextMenuHover};
  }

  ${({ disabled }) => disabled && `
    pointer-events: none;
    opacity: 0.5;
  `}
`;
StyledMenuItem.displayName = 'StyledMenuItem';

export const ArrowIcon = styled(ArrowSVG)`
    margin: auto 0px auto auto;
`;
ArrowIcon.displayName = 'ArrowIcon';

export const SubMenuContainer = styled.div`
  position: absolute;
  top: 0;
  left: 100%;
  min-width: 127px;
  background-color: ${({ theme }) => theme.backgrounds.actionDropDown};
  border: 1px solid ${({ theme }) => theme.borders.actionDropDown};
  box-shadow: 2px 2px 10px 0 ${({ theme }) => theme.shadows.actionDropDown};
  border-radius: 0.25rem;
  z-index: 4;
`;
SubMenuContainer.displayName = 'SubMenuContainer';
